import React from "react";

const CancelIcon = () => {
  return <img src="./img/icon-close-black.svg" alt="close" className="icon-file" />;
};

export default CancelIcon;
